import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import {
	Card,
	Form,
	Button,
	Row,
	Icon,
	Popconfirm,
	Spin,
	Tooltip,
	Input,
	Dropdown,
	Menu
} from "antd";

import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import RankerXArticleDrawer from "./components/RankerXArticleDrawer";
import ArticleBuilderDrawer from "./components/ArticleBuilderDrawer";
import USADrawer from "./components/USADrawer";
import { SpinnerServices } from "common/general";

import { locationPrefix } from "common/general";
import co from "co";
import _ from "lodash";
import PreviewArticleDrawer from "./components/PreviewArticleDrawer";
import ArticleForgeDrawer from "./components/ArticleForgeDrawer";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const MenuItem = Menu.Item;

@Form.create({
	onFieldsChange(props, changedFields, all) {		
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class ArticleForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};
	render() {
		return (
			<Form>
				<FormItem style={{ marginBottom: 10 }} label="Title">
					{this.props.form.getFieldDecorator("title", {
						rules: [
							{
								required: true,
								message: "Title is required"
							}
						]
					})(
						<TextArea
							style={{fontFamily: "Arial"}}
							rows={2}
							// style={{ resize: "none" }}
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							spellCheck="false"
						/>
					)}
				</FormItem>
				<FormItem style={{ marginBottom: 10 }} label="Body">
					{this.props.form.getFieldDecorator("body", {
						rules: [
							{
								required: true,
								message: "Body is required"
							}
						]
					})(
						<TextArea
							style={{fontFamily: "Arial"}}
							rows={6}
							// style={{ resize: "none" }}
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							spellCheck="false"
						/>
					)}
				</FormItem>
				<FormItem style={{ marginBottom: 10 }} label="Author Name">
					{this.props.form.getFieldDecorator("authorName", {
						rules: [
							{
								required: true,
								message: "Author name is required"
							}
						]
					})(<Input type="text" />)}
				</FormItem>
				<FormItem style={{ marginBottom: 10 }} label="Author Bio">
					{this.props.form.getFieldDecorator("authorBio", {
						rules: [
							{
								required: true,
								message: "Author bio is required"
							}
						]
					})(
						<TextArea
							style={{fontFamily: "Arial"}}
							rows={6}
							// style={{ resize: "none" }}
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							spellCheck="false"
						/>
					)}
				</FormItem>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
export default class ArticlePage extends Component {
	constructor(props) {
		super(props);
	}

	componentWillUnmount = () => {
		this.onFieldsChange.cancel();
	};

	mapPropsToFields = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		const article = articleStore.stateForm;
		let result = {
			title: Form.createFormField(article.title),
			body: Form.createFormField(article.body),
			authorName: Form.createFormField(article.authorName),
			authorBio: Form.createFormField(article.authorBio)
		};

		return result;
	};

	onFieldsChange = _.debounce(changedFields => {
		const {
			rootStore: { articleStore }
		} = this.props;
		articleStore.formChanged(changedFields);
	}, 200);

	validateForm = () => {
		// console.log("Called");
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	hideRankerXArticleDrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.hideRankerXArticleDrawer();
	};

	hideArticleBuilderDrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.hideArticleBuilderDrawer();
	};

	hideArticleForgeDrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.hideArticleForgeDrawer();
	};

	hideUSADrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.hideUSADrawer();
	};

	showPreviewArticleDrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.showPreviewArticleDrawer();
	}

	showRankerXArticleDrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.showRankerXArticleDrawer();
	};

	showArticleBuilderDrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.showArticleBuilderDrawer();
	};

	showArticleForgeDrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.showArticleForgeDrawer();
	};

	showUSADrawer = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.showUSADrawer();
	};

	handleDownloadArticleClick = ({ key }) => {
		if (key == "rankerXArticle") {
			this.showRankerXArticleDrawer();
			return;
		}
		if (key == "articleBuilder") {
			this.showArticleBuilderDrawer();
			return;
		}
		if (key == "ultraSpinnableArticle") {
			this.showUSADrawer();
		}
		if (key == "articleForgeArticle") {
			this.showArticleForgeDrawer();
		}
	};

	handleSpinArticleClick = ({ key }) => {
		const {
			rootStore: { articleStore }
		} = this.props;

		co(
			function*() {
				const error = yield this.validateForm();
				if (error) {
					return;
				}
				articleStore.spinArticle(key);
			}.bind(this)
		);
	};

	downloadRankerXArticle = payload => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.downloadRankerXArticle(payload);
	};

	downloadArticleBuilderArticle = payload => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.downloadArticleBuilderArticle(payload);
	};

	downloadArticleForgeArticle = payload => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.downloadArticleForgeArticle(payload);
	};

	downloadUSAArticle = payload => {
		const {
			rootStore: { articleStore }
		} = this.props;

		articleStore.downloadUSAArticle(payload);
	};

	saveArticle = () => {
		const {
			rootStore: { articleStore }
		} = this.props;

		co(
			function*() {
				const error = yield this.validateForm();
				if (error) {
					return;
				}
				articleStore.saveArticle();
			}.bind(this)
		);
	};

	render() {
		const {
			rootStore: { articleStore }
		} = this.props;

		const ui = articleStore.ui;
		const contentGroup = articleStore.contentGroup;
		const articleBuilderCategories = articleStore.articleBuilderCategories;

		let spinning = ui.loadingArticle == true || ui.spinningArticle == true;

		const breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			},
			{
				title: "Content Group: " + contentGroup.name,
				href: locationPrefix + "/content-group/" + contentGroup.id
			},
			{
				title: "Article"
			}
		];

		let downloadArticleMenu = (
			<Menu onClick={this.handleDownloadArticleClick}>				
				<Menu.Item key="rankerXArticle">Builtin Article Builder</Menu.Item>
				<Menu.Item key="articleForgeArticle">Article Forge Article</Menu.Item>
				<Menu.Item key="articleBuilder">ArticleBuilder.net</Menu.Item>
				<Menu.Item key="ultraSpinnableArticle">
					Ultra Spinnable Article
				</Menu.Item>
			</Menu>
		);

		let spinnerMenu = (
			<Menu onClick={this.handleSpinArticleClick}>
				{SpinnerServices.map(service => {
					return <Menu.Item key={service.key}>{service.name}</Menu.Item>;
				})}
			</Menu>
		);
		
		if (ui.loadingArticle == true) {
			// console.log("Loading Article");
		} else {
			// console.log("Done loading article");
		}
		return (
			<Fragment>
				{ui.loadingArticle == true ? (
					""
				) : (
					<PageHeaderLayout breadcrumbList={breadcrumbList} title="Article">
						<Card>
							<ArticleForgeDrawer
								ui={ui}
								hideDrawer={this.hideArticleForgeDrawer}								
								downloadArticleForgeArticle={this.downloadArticleForgeArticle}
							/>
							<RankerXArticleDrawer
								ui={ui}
								hideDrawer={this.hideRankerXArticleDrawer}
								articleBuilderCategories={articleBuilderCategories}
								downloadRankerXArticle={this.downloadRankerXArticle}
							/>
							<ArticleBuilderDrawer
								ui={ui}
								hideDrawer={this.hideArticleBuilderDrawer}
								articleBuilderCategories={articleBuilderCategories}
								downloadArticleBuilderArticle={
									this.downloadArticleBuilderArticle
								}
							/>
							<USADrawer
								ui={ui}
								hideDrawer={this.hideUSADrawer}
								downloadUSAArticle={this.downloadUSAArticle}
							/>
							<PreviewArticleDrawer />
							<Spin spinning={spinning}>
								<Dropdown overlay={downloadArticleMenu}>
									<Button type="primary">
										Download <Icon type="down" />
									</Button>
								</Dropdown>
								{' '}
								<Dropdown overlay={spinnerMenu}>
									<Button type="primary" loading={ui.spinningArticle}>
										Spin
									</Button>
								</Dropdown>
								{' '}
								<Button type="primary" onClick={this.showPreviewArticleDrawer} >Preview</Button>
								{' '}
								<Button
									type="primary"
									onClick={this.saveArticle}
									loading={ui.savingArticle == true}
									disabled={ui.articleChanged == false}
								>
									Save
								</Button>
								<ArticleForm
									fields={this.mapPropsToFields()}
									onFieldsChange={this.onFieldsChange}
									wrappedComponentRef={internalForm => {
										if (internalForm != null) {
											this.internalForm = internalForm;
										}
									}}
								/>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}
